(function () {
  const loader = document.getElementById('site-loader');

  if (!loader) return;

  // Only show once per browser session
  if (sessionStorage.getItem('shopifyLoaderShown') === 'true') {
    loader.remove();
    return;
  }

  // Mark as shown
  sessionStorage.setItem('shopifyLoaderShown', 'true');

  let hasHidden = false;

  function hideLoader() {
    if (hasHidden) return;
    hasHidden = true;

    // Start fade-out
    loader.classList.add('is-hidden');

    // Remove after fade completes
    setTimeout(function () {
      loader.remove();
    }, 700);
  }

  // Wait until the entire page is loaded
  if (document.readyState === 'complete') {
    hideLoader();
  } else {
    window.addEventListener('load', hideLoader, { once: true });
  }

  // Safety fallback
  setTimeout(hideLoader, 5000);
})();